module.exports = __webpack_public_path__ + "img/trial-to-basic-custom-poll.6c6745c9.svg";